import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.IntegrationModule.AnotherCompanyIntegratedPopup', {
    title: '{integrationName} organisation is already connected to ApprovalMax',
    description: `{integrationName} org is already connected to another ApprovalMax org. Please disconnect it or connect different {integrationName} org.
    Should you have any questions, please <supportlink>contact us</supportlink>.`,
    cancelButtonText: 'Cancel',
});
